import Request from './request'

const Users = {
  // TODO Перенести запрос в другой Контроллер
  getProps(callback) {
    Request.get('users/props').then(callback).catch(this.bad_answer)
  },

  getUserSelectOptions (callback, bad_answer) {
    Request.get('users/me/select-options').then(callback).catch(bad_answer)
  },
  getUserProfile (callback, bad_answer) {
    Request.get('users/me/profile').then(callback).catch(bad_answer)
  },
  updateUserSettings (params, callback) {
    Request.put('users/me/settings', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },


  getUsersList (params, callback) {
    Request.get('users', params).then(callback).catch(this.bad_answer)
  },
  getUserInfo (id, callback) {
    Request.get('users/' + id).then(callback).catch(this.bad_answer)
  },
  getUserInfoByNick (nick, callback) {
    Request.get('users/by-nick/' + nick).then(callback).catch(this.bad_answer)
  },
  createUser (params, callback) {
    Request.post('users', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateUser (id, params, callback) {
    Request.put('users/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },

  updateUserGroups (id, params, callback) {
    Request.put('users/' + id + '/groups', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Users
